import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";

/**
 * @method getContextPath
 * @description 获取根路径
 * @return {String} - 应用页面的根路径 '/emap'
 */
// export const getContextPath = function () {
//   const path = window.location.pathname
//   const end = path.indexOf('/sys/')
//   return path.substring(0, end) || '/emap'
// }

/**
 * @method getAppPath
 * @description 获取应用路径
 * @return {String} - 当前应用路径 "/emap/sys/student_app"
 */
// export const getAppPath = () => {
//   var path = window.location.pathname
//   var start = path.indexOf('/sys/') + '/sys/'.length
//   var tmpPath = path.substring(start, path.length)
//   var appPath = tmpPath.substring(0, tmpPath.indexOf('/'))
//   return getContextPath() + (appPath ? '/sys/' : '/sys')
// }

/**
 * @method getAbsPath
 * @description 获取绝对路径
 * @param {String} pagePath 传入的相对路径
 * @return {String} - 绝对路径 "/emap/sys/student_app/modules/xsxxdbwh.do"
 */
export const getAbsPath = pagePath => {
  if (pagePath === undefined) {
    console && console.warn('WIS_EMAP_SERV.getAbsPath 传参为空');
    return;
  }

  if (pagePath.substring(0, 7) === 'http://' || pagePath.substring(0, 8) === 'https://' || pagePath.substring(0, 1) === '/') {
    return pagePath;
  } // return getAppPath() + '/' + pagePath


  return '/' + pagePath;
};
export const joinActionIdToDoUrl = (url, actionID) => {
  url = url.trim();

  if (/\.do$/.test(url)) {
    url = url.replace(/\.do$/, '/' + actionID + '.do');
  } else if (/\.do\?/.test(url)) {
    url = url.replace(/\.do\?/, '/' + actionID + '.do?');
  } else if (/\.do#/.test(url)) {
    url = url.replace(/\.do#/, '/' + actionID + '.do#');
  } else if (/\.do\/#/.test(url)) {
    url = url.replace(/\.do\/#/, '/' + actionID + '.do/#');
  }

  return url;
};
/**
 * 请求远程地址，统一封装
 */

export const request = ({
  url,
  method = 'POST',
  headers = {
    'Content-Type': 'application/json'
  },
  query = null,
  body,
  beforeSend = null,
  // 发送请求之前可通过此函数加入自定义处理
  vm // 处理高级搜索的 schema 时需要

} = {}) => {
  if (!url) {
    return Promise.reject(new Error('URL 未设置'));
  } // if (query) {
  //   const queryStr = Object.keys(query).map(item => `${item}=${query[item]}`).join('&')
  //   url += url.includes('?') ? `&${queryStr}` : `?${queryStr}`
  // }


  const req = {
    method,
    url: url,
    query,
    // traditional: true,
    body,
    headers,
    credentials: 'include'
  };

  if (beforeSend) {
    beforeSend(req);
  }

  if (notEmptyObject(req.query)) {
    req.body = Object.assign(req.body || {}, req.query);
  }

  const searchCondition = req.querySetting;

  if (notEmptyObject(searchCondition)) {
    req.body = req.body || {};
    const builderMap = vm.searchMeta.reduce((ret, item) => ({ ...ret,
      [item.name]: item.defaultBuilder || 'equal'
    }), {});
    const querySetting = Object.keys(searchCondition).map(key => ({
      name: key,
      value: searchCondition[key],
      builder: builderMap[key],
      linkOpt: 'AND'
    })).filter(item => item.value !== '');

    if (querySetting && querySetting.length > 0) {
      req.body.querySetting = JSON.stringify(querySetting);
    }
  }

  if (req.body) {
    req.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    req.body = Object.keys(req.body).map(key => `${key}=${req.body[key]}`).join('&');
  }

  return fetch(req.url, req).then(res => res.json());
};

function notEmptyObject(obj) {
  return obj && Object.keys(obj).length > 0;
}